import type { Theme } from "@mui/material/styles";

import { alpha } from "@mui/material";

export const OVERRIDDEN_CELL_CLASS = "grid-cell-overridden";

const OVERRIDDEN_CELL_TINT_ALPHA = 0.35;
const OVERRIDDEN_CELL_BORDER_WIDTH = "3px";

export const overriddenCellGlobalStyle = (theme: Theme) => ({
	backgroundColor: alpha(theme.palette.info.main, OVERRIDDEN_CELL_TINT_ALPHA),
	borderLeft: `${OVERRIDDEN_CELL_BORDER_WIDTH} solid ${theme.palette.info.main}`
});

export const buildOverriddenCellClassRules = <TRow>(isOverridden: (row: TRow | undefined) => boolean) => ({
	[OVERRIDDEN_CELL_CLASS]: (params: { data?: TRow }) => isOverridden(params.data)
});

export default overriddenCellGlobalStyle;
